
import { mapState } from 'vuex';
import { formatCurrency } from '@/utils/currency';
import FSlider from '@/components/atoms/forms/h-slider';
import FInfoTooltip from '@/components/molecules/tooltips/info-tooltip';

export default {
  name: 'PensionPlaygroundContributionSliders',

  components: {
    FSlider,
    FInfoTooltip,
  },

  computed: {
    ...mapState({
      recommendedOneTimeContribution: (state) =>
        state['pension-calculator'].outputs
          .slider_one_time_investment_recommend,
      recommendedMonthlyContribution: (state) =>
        state['pension-calculator'].outputs.slider_monthly_investment_recommend,
      slider_one_time_investment_min: (state) =>
        state['pension-calculator'].outputs.slider_one_time_investment_min,
      slider_one_time_investment_max: (state) =>
        state['pension-calculator'].outputs.slider_one_time_investment_max,
      slider_monthly_investment_min: (state) =>
        state['pension-calculator'].outputs.slider_monthly_investment_min,
      slider_monthly_investment_max: (state) =>
        state['pension-calculator'].outputs.slider_monthly_investment_max,
      ownHomeOneTimeContributionThreshold: (state) =>
        state['pension-calculator'].outputs
          .threshold_own_home_one_time_investment,
      investmentPropertyOneTimeContributionThreshold: (state) =>
        state['pension-calculator'].outputs
          .threshold_investment_property_one_time_investment,
      ownHomeMonthlyContributionThreshold: (state) =>
        state['pension-calculator'].outputs
          .threshold_own_home_monthly_investment,
      investmentPropertyMonthlyContributionThreshold: (state) =>
        state['pension-calculator'].outputs
          .threshold_investment_property_monthly_investment,
    }),

    monthlyContribution: {
      get() {
        return this.$store.state['pension-calculator'].inputs
          .slider_monthly_contribution;
      },
      set(value) {
        this.setStoreProperty('slider_monthly_contribution', value);
      },
    },

    monthlySuggestion() {
      const amount = formatCurrency(this.recommendedMonthlyContribution);
      return `${amount} € ${this.$t('suggested')}`;
    },

    oneTimeContribution: {
      get() {
        return this.$store.state['pension-calculator'].inputs
          .slider_one_time_contribution;
      },
      set(value) {
        this.setStoreProperty('slider_one_time_contribution', value);
      },
    },

    oneTimeSuggestion() {
      const amount = formatCurrency(this.recommendedOneTimeContribution);
      return `${amount} € ${this.$t('suggested')}`;
    },

    tooLowMonthlyContributionTooltip() {
      const tooltips = [];

      if (this.monthlyContribution < this.ownHomeMonthlyContributionThreshold) {
        tooltips.push(this.$t('tooLowMonthlyContributionOwnHomeTooltip'));
      }

      if (
        this.monthlyContribution <
        this.investmentPropertyMonthlyContributionThreshold
      ) {
        tooltips.push(
          this.$t('tooLowMonthlyContributionInvestmentPropertyTooltip'),
        );
      }

      if (!tooltips.length) {
        return null;
      }

      return tooltips.join('<br><br>');
    },

    tooLowOneTimeContributionTooltip() {
      const tooltips = [];

      if (this.oneTimeContribution < this.ownHomeOneTimeContributionThreshold) {
        tooltips.push(this.$t('tooLowOneTimeInvestmentOwnHomeTooltip'));
      }

      if (
        this.oneTimeContribution <
        this.investmentPropertyOneTimeContributionThreshold
      ) {
        tooltips.push(
          this.$t('tooLowOneTimeInvestmentInvestmentPropertyTooltip'),
        );
      }

      if (!tooltips.length) {
        return null;
      }

      return tooltips.join('<br><br>');
    },
  },

  methods: {
    scrollToPlayground(section) {
      this.$vuetify.goTo(section, {
        offset: 12,
        easing: 'easeInOutCubic',
      });
    },

    setStoreProperty(property, value) {
      this.$store.commit('pension-calculator/setInputProperty', {
        property,
        value,
      });
    },
  },
};
